import { connect } from 'react-redux';

import {
  mapStateToProps,
  mapDispatchToProps,
} from './props';

import AdminViewAllMeetingsView from './AdminViewAllMeetingsView';

export default connect(mapStateToProps, mapDispatchToProps)(AdminViewAllMeetingsView);
